/**
 * 文字入场（roll）
 * 2019-5-31
 */
(function (root, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        // CommonJS
        module.exports = factory(this);
    } else {
        //  全局变量
        factory(root);
    }
})(this, function (root) {
     // 类构造函数
     function con(sprite, option) {
        this.type = option.code || 'Roll';
    }
  
    var methods =  {
        // 分割文字
        _splitText: function (sprite, player) {
            var _this = this,
                st    = this._escape2Html(
                            sprite.text
                                .replace(/<div.*?>|<br.*?>/g, '')
                                .replace(/\r/g, '\n')
                        );
            var $div = player.ele.children('div').eq(0).empty(); //清空原内容
                // $font = $div.children('div'); // 字体div

            this.textid = 'player-text-sprite-' + sprite.uuid;
            $div.attr({id: this.textid}).css(Object.assign({}, sprite.font, sprite.artStyle, {
                fontFamily: sprite.fontFamilyUrl,
                lineHeight: sprite.lineHeight || 1
            }));


            var width = sprite.ele.width() * sprite.editor.scale, // 文本容器的宽
                height = sprite.ele.height() * sprite.editor.scale, // 文本容器的高
                $fontDiv = player.ele.children('div'),
                font = $fontDiv.css('font');

            // 兼容firefox
            if(!font) {
                font = '' + $fontDiv.css('font-style');
                font = font + ' ' + $fontDiv.css('font-variant');
                font = font + ' ' + $fontDiv.css('font-weight');
                font = font + ' ' + 'normal';
                font = font + ' ' + $fontDiv.css('font-size');
                font = font + ' / ' + $fontDiv.css('line-height');
                font = font + ' ' + $fontDiv.css('font-family');
            }

            this.fontString = font;
            // 创建文字对象
            // 该对象是一个三维数组，第一维是以\n为分隔的行，
            // 第二维是以自然超出边界而分的行，
            // 第三维是每个自然行的字符信息，包括content, index和行号
            var textObj = [], AllLine;
            var emptyLine = 0; // 记录空行

            st.split('\n').forEach(function(part, i, st) {
                if (part === '') ++emptyLine; // 空行+1
                textObj[i] = [];
                var prev = textObj[i - 1];

                // 计算在遇到空行之前有多少个非空行
                var noEmptyLine = 0; // 记录非空行
                for (var j = 0; j < i; j ++) {
                    if (part !== '') {
                        noEmptyLine += textObj[j].length || 0;
                    }
                }

                // 计算前一个段落的总行数
                var prev_lines = prev ? prev[0]
                    ? prev[prev.length - 1][prev[prev.length - 1].length - 1].line
                    : emptyLine + noEmptyLine : 0;

                // 遍历每个段落，完成textObj的数据结构
                part.split('').reduce(function(l, t, index, arr) {
                    var subWidth, line;
                    
                    switch( sprite.versionAnyway){   // 横竖版
                        case 'Vertical': // 竖版
                            subWidth = _this._getStringInfo(part.slice(0, index + 1), font, 'Vertical').height;
                            line = Math.ceil( subWidth / height );
                            break;
                        default:
                            subWidth = _this._getStringInfo(part.slice(0, index + 1), font).width;
                            line = Math.ceil( subWidth / width );
                    }
                    var isEndOfLine = false; //分段的行末
                    if (index === arr.length - 1) {
                        isEndOfLine = true;
                    }

                    // 非分段行（自然换行） l < line 则上一个元素为行末
                    if (l < line) {
                        var tmp = textObj[i][line - 2];
                        if (!tmp) return;
                        tmp[tmp.length - 1].isEndOfLine = true;
                        l++;
                    }

                    if (!textObj[i][line - 1]) {
                        textObj[i][line - 1] = [{
                            content: t,
                            index: index,
                            line: line + prev_lines /*+ (emptyLine ? emptyLine + 1 : 0)*/,
                            isEndOfLine: isEndOfLine
                        }];
                    } else {
                        textObj[i][line - 1].push({
                            content: t,
                            index: index,
                            line: line + prev_lines /*+ (emptyLine ? emptyLine + 1 : 0)*/,
                            isEndOfLine: isEndOfLine
                        });
                    }

                    // if (_flag && index === arr.length - 1) emptyLine = 0;
                    AllLine = line + prev_lines;
                    return l;
                }, 1);
            });

            // 处理每行文字
            textObj.forEach(function(o) {

                o.forEach(function(text) {
                    // 当前行的长度
                    // var sub = st.slice(text[0].index, text[0].index + text.length),
                    
                    var sInfo = _this._getStringInfo(text[0].content, font);
                    var yos = (text[0].line - 1) * sInfo.height;
                    
                    switch( sprite.versionAnyway){   // 横竖版
                        case 'Vertical': // 竖版
                            sInfo = _this._getStringInfo(text[0].content, font,  'Vertical');
                            yos = (AllLine - text[0].line) * sInfo.width;
                            break;
                        default:
                            yos = (text[0].line - 1) * sInfo.height;
                    }

                    var sub = [], w;
                    text.forEach(function(te) {
                        sub.push(te.content);
                    });

                    sub = sub.join('');
                    w = _this._getStringInfo(sub, font).width;
                    h = _this._getStringInfo(sub, font,  'Vertical').height;

                    text.reduce(function(po, t, index, arr) {
                        var TsInfo = _this._getStringInfo(t.content, font);
                        switch( sprite.versionAnyway){   // 横竖版
                            case 'Vertical': // 竖版
                                TsInfo = _this._getStringInfo(t.content, font, 'Vertical');
                                $('<div></div>').css({
                                    opacity : 0,
                                    backgroundColor: sprite.artType === 'Inset' ? sprite.font.color: '',
                                    '-webkit-background-clip': 'text',
                                    position: 'absolute',
                                    left: yos,
                                    top: po.y, 
                                    textDecoration : sprite.font.textDecoration || 'none',
                                }).attr({
                                    "is-end-of-line": t.isEndOfLine ? 'true' : null
                                }).text(t.content).appendTo($div);
                                return {
                                    x: 0,
                                    y:  po.y + TsInfo.height
                                }
                                break;
                            default:
                                $('<div></div>').css({
                                    opacity : 0,
                                    backgroundColor: sprite.artType === 'Inset' ? sprite.font.color: '',
                                    '-webkit-background-clip': 'text',
                                    position: 'absolute',
                                    left: po.x,
                                    top: po.y + (t.line - 1) * TsInfo.height,
                                    textDecoration : sprite.font.textDecoration || 'none',
                                }).attr({
                                    "is-end-of-line": t.isEndOfLine ? 'true' : null
                                }).text(t.content).appendTo($div);
                                return {
                                    x: po.x + TsInfo.width,
                                    y: 0
                                }

                        }
                        
                    }, {
                        x: _this._textMakeup(sprite.font.textAlign, {
                                boxWidth: width,
                                lineWidth: w
                            }),
                        y:  _this._textMakeup(sprite.font.textAlign, {
                                boxHeight: height,
                                lineHeight:  h,
                                type : sprite.versionAnyway
                            }),
                    });
                });
            });


            this.textele = $div;

            return textObj;
        },

        /**
         * 获取字符的长宽等信息
         * @param {string} s 字符
         * @param {string} font 字体
         * @returns {object}
         */
        _getStringInfo: function (s, font, type) {
            var f = font || '12px arial',
                o = $('<div></div>')
                        .text(s)
                        .css({
                            'position': 'absolute',
                            'float': 'left',
                            'visibility': 'hidden',
                            'white-space': 'pre',
                            'font': f,
                            'letterSpacing': parseFloat(this.sprite.letterSpacing * (~~(parseInt(this.sprite.font.fontSize) / 10)) || 0) + 'px'
                        })
                        .appendTo($('body'));
            if(type && type == 'Vertical'){
                o.css({
                    'writing-mode': 'vertical-rl'
                });
            }
            var result = {
                width: o.width(),
                height: o.height()
            }

            o.remove();

            return result;
        },

        /**
         * 排版算法（居中，居左，居右）
         * @param {String} type 类型，有'center', 'left', 'right'
         * @param {Object} w 对象，包含文本框宽度及当前行文字宽度
         * @return {number} 返回第一个字符的left值
         */
        _textMakeup: function(type, w) {
            var result;
            if(w && w.type){
                switch( w.type){   // 横竖版
                    case 'Vertical': // 竖版
                        switch(type) {
                            case 'left':
                                result = 0;
                                break;
                            case 'right':
                                result = w.boxHeight - w.lineHeight
                                break;
                            case 'center':
                            default:
                                result = (w.boxHeight - w.lineHeight) / 2;
                                // console.log(w)
                                break;
                        }
                        break;
                    default:
                        result = 0;                        
                }
            }else{
                switch(type) {
                    case 'left':
                        result = 0;
                        break;
                    case 'right':
                        result = w.boxWidth - w.lineWidth
                        break;
                    case 'center':
                    default:
                        result = (w.boxWidth - w.lineWidth) / 2;
                        // console.log(w)
                        break;
                }
            }
            return result;
        },
        // 将html实体转义为html标签
        _escape2Html: function(str) {
            var arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
            return str.replace(/&(lt|gt|nbsp|amp|quot);/ig,function(all,t){return arrEntities[t];});
        },
        /**
         * 文字透明度
         * @param {number} f 需要f帧完成渐变
         * @param {number} current 当前帧数
         */
        _opacityShow: function(f, current) {
            var result =  (1 / f) * current;
            return result > 1 ? 1 : result <= 0 ? 0 : result;
        },
        // 文字偏移字符串
        _transformShow: function(f, current, type) {
            if (current > f) {
                current = f
            }else if(current < 0) {
                current = 0
            }
            var matrix = this._easeOutQuint(current, 200, -200, f)
            return 'translate'+(type === 'Vertical'?'Y':'X')+'('+ matrix +'px) '
        },
        // 文字旋转字符串
        _transformRotate: function(f, current) {
            if (current > f) {
                current = f
            }else if(current < 0) {
                current = 0
            }
            var rotate = this._easeOutBack(current, 360, -360, f, 1.1)
            return 'rotate('+ rotate +'deg)'
        },
        // 缓动函数（文字偏移）
        _easeOutQuint: function (t, b, c, d) {
            return c*((t=t/d-1)*t*t*t*t + 1) + b;
        },
        // 缓动函数（文字旋转实现）
        _easeOutBack: function(t, b, c, d, s) {
            if (s == undefined) s = 1.1;
            return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
        },
        /**
         * 计算文字绘制时间
         * @param {jQuery} div 文字框对象
         * @return {number} 返回单个字符绘制的时间
         */
        _getTextAnimTime: function (textDiv) {
            // 动画总时间
            var entrance = this.entranceAnim,
                exit = this.exitAnim,
                total = exit.start - entrance.start;

            // 换行次数
            var stringEles = textDiv.children('div');
                textNum = stringEles.length,
                newLine = 0;
            for(var i = 0; i < textNum; i ++) {
                var currentEle = stringEles.eq(i);
                if (
                    currentEle.attr('is-end-of-line')
                    && i !== stringEles.length - 1
                ) {
                    newLine ++;
                }
            }

            // 每换行一次，视为增加两个字符的长度
            var t = 100 * (textNum + newLine * 2 + 10) + 200;

            if (t > total) {
                // 超出长度，重新计算单个字符绘制时间
                return (total - 200) / (textNum + newLine * 2 + 10);
            } else {
                return 100;
            }
        },

        init: function() {
            var _this = this, sprite = this.sprite,
                editor = sprite.editor;

            return this.supr().then(function() {
                var playerSprite = editor.player.spritesDict[sprite.uuid];
                // 分割字符串，生成div串
                _this._splitText(sprite, playerSprite);

                var textDiv = playerSprite.ele.children('div#' + _this.textid),
                    $text = textDiv.children('div'),
                    textNum = $text.length,
                    msPerString = _this._getTextAnimTime(textDiv) / 1000 * _this.frameRate,
                    framePerString = msPerString * 10, // 特定帧内每个字符需要的帧数
                    entrance = _this.animFrame.entrance;
                // 为每个字符分配起始和结束帧
                // 默认每字字符在100ms内显示完成，若超过动画入场退场的总时间，则再加快
                // 中间遇到换行，下一行起始时间往后顺延两个字符时间单位
                _this.item = [];
                for (var i = 0; i < textNum; i++) {
                    var currentEle = $text.eq(i),
                        isEndOfLine = currentEle.attr('is-end-of-line') ? true : null,
                        _start = entrance.start;

                    if (_this.item[i - 1]) {
                        _start = _this.item[i - 1].start + msPerString;
                    }

                    // 若上一行是行末，则本行的起始时间和结束时间往右延两个单位
                    if (_this.item[i - 1] && _this.item[i - 1].isEndOfLine) {
                        _start = _this.item[i - 1].start + msPerString * 2;
                    }

                    _end = _start + framePerString;

                    _this.item.push({
                        ele: currentEle,
                        isEndOfLine: isEndOfLine,
                        start: _start,
                        end: _end
                    });
                }

                playerSprite.ele.find('#write-hand-wrapper-' + sprite.uuid).remove();

                _this.isInit = true;
                _this.playerSprite = playerSprite; 

            }).catch(function(err) {
                console.error(err);
            });
        },

        // show方法
        show: function(frame) {
            this.supr(frame);

            if(!this.isInit) return;

            var sprite = this.sprite,
                _this = this;

            var player = this.playerSprite.ele;
                // textDiv = player.children('div');

            var animFrame = this.animFrame,
                entrance = animFrame.entrance,
                exit = animFrame.exit;

            // 进场后播放
            if (frame >= entrance.start) {
                player.show();
                this.item.forEach(function(item, i) {
                    var cf = frame - item.start,
                        dur = item.end - item.start;
                    item.ele.css({
                        opacity: _this._opacityShow(dur/4, cf),
                        transform: _this._transformShow(dur/1.5, cf, sprite.versionAnyway) + _this._transformRotate(dur, cf)
                    });

                });

                if (frame < exit.start) this.clearPopFadeExit(player);
                // 退场前，校正位置
                if (frame <= exit.start && player.css('top') !== sprite.positionTop) {
                    player.css({ top: sprite.positionTop, left: sprite.positionLeft});
                }

                // 退场
                if (frame > exit.start && frame <= exit.end) {
                    _this.showExitAnim(frame);
                }

                // 退场后隐藏
                if (frame > exit.end) {
                    player.hide();
                }
            } else {
                this.item.forEach(function(item, i) {
                    item.ele.css({
                        opacity: 0
                    });
                });
            }
        }
    }
  
    var statics = {}

    if (root.AnimEditor) {
        root.AnimEditor.extendEffect('Roll', con, methods, statics);
        return;
    }

    return function(AnimEditor) {
        AnimEditor.extendEffect('Roll', con, methods, statics);
    }
})
  


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/sprite-effects/roll.js
// module id = gm9L
// module chunks = 16